"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditSettings = void 0;
const button_1 = require("client/components/material/button");
const settings_1 = require("client/components/settings");
const setting_1 = require("shared/setting");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
require("./edit-settings.less");
const ramda_1 = require("ramda");
const defaultSettings = {
    adjudicationOffsetTime: {
        category: setting_1.SettingCategory.Claim,
        id: "adjudicationOffsetTime",
        label: "Adjudication Offset Time (hours)",
        title: "",
        type: setting_1.ItemTypes.Number,
        value: DEFAULT_SITE_SETTINGS.adjudicationOffsetTime
    },
    autoClaimReverseTime: {
        category: setting_1.SettingCategory.Claim,
        id: "autoClaimReverseTime",
        label: "Automatically reverse paid claims time",
        title: "",
        type: setting_1.ItemTypes.Time,
        value: DEFAULT_SITE_SETTINGS.autoClaimReverseTime
    },
    dispenseScan: {
        category: setting_1.SettingCategory.Claim,
        id: "dispenseScan",
        label: "Enable claim dispense barcode scan",
        title: "",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.dispenseScan
    },
    eowEmailAddress: {
        category: setting_1.SettingCategory.Email,
        id: "eowEmailAddress",
        label: "EOW Address (Blank for None)",
        title: "",
        type: setting_1.ItemTypes.String,
        value: DEFAULT_SITE_SETTINGS.eowEmailAddress
    },
    orderApprovalEmailAddress: {
        category: setting_1.SettingCategory.Email,
        id: "orderApprovalEmailAddress",
        label: "Order Submission Approval Email",
        title: "",
        type: setting_1.ItemTypes.String,
        value: DEFAULT_SITE_SETTINGS.orderApprovalEmailAddress
    },
    orderCheckInDays: {
        category: setting_1.SettingCategory.Email,
        id: "orderCheckInDays",
        label: "Order Check-In Notification (Days)",
        title: "",
        type: setting_1.ItemTypes.Number,
        value: DEFAULT_SITE_SETTINGS.orderCheckInDays
    },
    sendClinicAdminCycleCountAlertEmail: {
        category: setting_1.SettingCategory.Email,
        id: "sendClinicAdminCycleCountAlertEmail",
        label: "Clinic Admin",
        title: "Cycle count alert email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendClinicAdminCycleCountAlertEmail
    },
    sendClinicManagerCycleCountAlertEmail: {
        category: setting_1.SettingCategory.Email,
        id: "sendClinicManagerCycleCountAlertEmail",
        label: "Clinic Manager",
        title: "Cycle count alert email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendClinicManagerCycleCountAlertEmail
    },
    sendEmailNotificationFrequency: {
        category: setting_1.SettingCategory.Email,
        id: "sendEmailNotificationFrequency",
        label: "Assets Summary Frequency:",
        title: "",
        type: setting_1.ItemTypes.Group,
        value: DEFAULT_SITE_SETTINGS.sendEmailNotificationFrequency
    },
    sendIntentNotificationAdmin: {
        category: setting_1.SettingCategory.Email,
        id: "sendIntentNotificationAdmin",
        label: "Admin",
        title: "Intent notification email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationAdmin
    },
    sendIntentNotificationClinicAdmin: {
        category: setting_1.SettingCategory.Email,
        id: "sendIntentNotificationClinicAdmin",
        label: "Clinic Admin",
        title: "Intent notification email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationClinicAdmin
    },
    sendIntentNotificationClinicManager: {
        category: setting_1.SettingCategory.Email,
        id: "sendIntentNotificationClinicManager",
        label: "Clinic Manager",
        title: "Intent notification email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationClinicManager
    },
    sendIntentNotificationClinicUser: {
        category: setting_1.SettingCategory.Email,
        id: "sendIntentNotificationClinicUser",
        label: "Clinic User",
        title: "Intent notification email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationClinicUser
    },
    sendIntentNotificationManager: {
        category: setting_1.SettingCategory.Email,
        id: "sendIntentNotificationManager",
        label: "Manager",
        title: "Intent notification email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationManager
    },
    sendIntentNotificationUser: {
        category: setting_1.SettingCategory.Email,
        id: "sendIntentNotificationUser",
        label: "User",
        title: "Intent notification email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationUser
    },
    sendProvAlertEmails: {
        category: setting_1.SettingCategory.Email,
        id: "sendProvAlertEmails",
        label: "Provider",
        title: "Provider assets email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendProvAlertEmails
    },
    sendSiteAlertEmailsAdmin: {
        category: setting_1.SettingCategory.Email,
        id: "sendSiteAlertEmailsAdmin",
        label: "Clinic Admin",
        title: "Pharmacy assets email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendSiteAlertEmailsAdmin
    },
    sendSiteAlertEmailsManager: {
        category: setting_1.SettingCategory.Email,
        id: "sendSiteAlertEmailsManager",
        label: "Clinic Manager",
        title: "Pharmacy assets email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendSiteAlertEmailsManager
    },
    sendUserAlertEmails: {
        category: setting_1.SettingCategory.Email,
        id: "sendUserAlertEmails",
        label: "User",
        title: "User assets email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendUserAlertEmails
    },
    sendUserCycleCountAlertEmail: {
        category: setting_1.SettingCategory.Email,
        id: "sendUserCycleCountAlertEmail",
        label: "User",
        title: "Cycle count alert email recipients: ",
        type: setting_1.ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendUserCycleCountAlertEmail
    },
    signaturePadTimeout: {
        category: setting_1.SettingCategory.Pad,
        id: "signaturePadTimeout",
        label: "Signature Pad Timeout (minutes)",
        title: "",
        type: setting_1.ItemTypes.Number,
        value: DEFAULT_SITE_SETTINGS.signaturePadTimeout // minutes
    }
};
let EditSettings = class EditSettings extends React.Component {
    constructor() {
        super(...arguments);
        this.status = ui_1.FormStatus.Clean;
        this.isStatusCancel = false; // E-105 new
        /** Bumped on Reset so the settings form drops unsaved switch and dropdown state. */
        this.resetNonce = 0;
        /** Deep copy of the last loaded or successfully saved pharmacy. */
        this.savedSite = null;
        this.isChanged = () => this.status === ui_1.FormStatus.Dirty;
        this.openConfirmationModal = () => this.isStatusCancel = true; // E-105 new
        this.closeConfirmationModal = () => this.isStatusCancel = false; // E-105 new
        // E-105 new
        this.onConfirmFlagFunc = (allowSiteCopayCollection) => {
            // Save a copy so a failed save does not leave the flag on the store site (which drives the Financial tab).
            callable_1.callable(this.props.onSave)(Object.assign(Object.assign({}, this.site), { allowSiteCopayCollection }));
            if (this.status === ui_1.FormStatus.Dirty) {
                this.status = ui_1.FormStatus.Clean;
            }
            this.isStatusCancel = false;
        };
        this.handleSubmit = () => {
            this.isStatusCancel = true; // E-105 new
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
        this.handleClear = () => {
            if (!this.site || !this.savedSite)
                return;
            const saved = ramda_1.clone(this.savedSite);
            this.site.settings = saved.settings;
            this.site.assignedProviders = saved.assignedProviders;
            this.site.allowSiteForESign = saved.allowSiteForESign;
            this.site.allowSiteForSelection = saved.allowSiteForSelection;
            this.site.allowSiteCopayCollection = saved.allowSiteCopayCollection;
            this.site.siteClaimApprovalDetermination = saved.siteClaimApprovalDetermination;
            this.site.siteMinTransactionFee = saved.siteMinTransactionFee;
            this.site.isTransactionFeeUpdated = saved.isTransactionFeeUpdated;
            this.status = ui_1.FormStatus.Clean;
            this.isStatusCancel = false;
            this.resetNonce += 1;
        };
        this.handleChange = (values) => {
            if (this.site) {
                this.site.settings = values;
                if (this.status === ui_1.FormStatus.Clean) {
                    this.status = ui_1.FormStatus.Dirty;
                }
            }
        };
    }
    UNSAFE_componentWillMount() {
        if (this.props.site) {
            this.site = this.props.site;
            this.savedSite = ramda_1.clone(this.props.site);
        }
    }
    UNSAFE_componentWillReceiveProps(props) {
        // A new object arrives on load and after a successful save. In-place edits keep the same object.
        if (props.site && props.site !== this.site) {
            this.site = props.site;
            this.savedSite = ramda_1.clone(props.site);
        }
    }
    render() {
        return (React.createElement("div", { className: "edit-settings" }, store_1.usersStore.permissions.UpdatePharmacy ? (React.createElement(ui_1.UiForm, { buttons: [
                React.createElement(button_1.MaterialButton, { className: "btnClear", onClick: this.handleClear }, "Reset settings"),
                React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                "Save"
            ], loading: this.props.loading, 
            // status={this.props.status}
            status: this.status, saved: "Saved", onSubmit: this.handleSubmit, error: this.props.error, isChanged: this.isChanged },
            React.createElement("div", { className: "main" },
                React.createElement("h3", null, "Settings"),
                React.createElement("div", { className: "site-settings" },
                    React.createElement("div", { className: "row" },
                        React.createElement(settings_1.SettingsComponent, { data: (this.site &&
                                ramda_1.mergeDeepRight(defaultSettings, this.site.settings || {})) ||
                                defaultSettings, defaultData: defaultSettings, onChange: this.handleChange, site: this.site, isStatusCancel: this.isStatusCancel, onCloseModal: this.closeConfirmationModal, onConfirmFlag: this.onConfirmFlagFunc, resetNonce: this.resetNonce })))))) : (store_1.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], EditSettings.prototype, "site", void 0);
__decorate([
    mobx_1.observable
], EditSettings.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], EditSettings.prototype, "isStatusCancel", void 0);
__decorate([
    mobx_1.observable
], EditSettings.prototype, "resetNonce", void 0);
EditSettings = __decorate([
    mobx_react_1.observer
], EditSettings);
exports.EditSettings = EditSettings;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-settings/edit-settings.tsx
// module id = 4060
// module chunks = 0